export default {"src":"/_next/static/media/arrow-narrow-left.cfa463dd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};